














































































































import {extend, ValidationObserver, ValidationProvider} from 'vee-validate';
import {Component, Vue} from 'vue-property-decorator';
import PopupBackground from "../components/PopupBackground.vue";
import SmallButton from "../components/input/SmallButton.vue";
import BigButton from '../components/input/BigButton.vue';
import MainPageHeader from "../components/MainPageHeader.vue";
import DefaultInputField from "../components/input/DefaultInputField.vue";
import InputError from "@/components/input/InputError.vue";
import EmailRecoveryPopup from '@/components/EmailRecoveryPopup.vue'
import {min, required} from "vee-validate/dist/rules";
import CircleLoadingButton from "@/components/input/CircleLoadingButton.vue";
import {getAccountService} from '@/services/accountService'
import {getAndroidContext} from '@/services/sessionProps'
import {getAuthService} from "../services/authService";

extend('password', {
  params: ['target'],
  // @ts-ignore
  validate(value, {target}) {
    return value === target;
  },
  message: 'Hasła muszą być takie same.',
});

extend('required', {
  ...required,
  message: 'Pole jest wymagane',
});

extend('min', {
  ...min,
  message: 'Hasło musi mieć przynajmniej 8 znaków.',
});


@Component
(
    {
      name: 'AccountRecovery',
      components: {
        SmallButton,
        BigButton,
        DefaultInputField,
        PopupBackground,
        MainPageHeader,
        ValidationProvider,
        ValidationObserver,
        InputError,
        CircleLoadingButton,
        EmailRecoveryPopup
      },
      data() {
        return {
          tokenURL: false,
          newPassword: '',
          repeatedPassword: '',
          isAndroidContext: false,
          androidSuccessPopup: false,
        }
      },
      mounted () {
        const url = document.URL;
        if (url.includes('token')) {
          //@ts-ignore
          this.tokenURL = true;
        }
        else {
          //@ts-ignore
          this.tokenURL = false;
        }
      }
    },
)
export default class AccountRecovery extends Vue {
  email: string = "";
  isLoading: Boolean = false
  loadingError: Boolean = false
  animate: Boolean = false
  isRecoveryPopup1: Boolean = false
  isRecoveryPopup0: Boolean = false
  failurePopupPassword: Boolean = false
  emailNotExist: Boolean = false
  isAndroidContext: boolean | undefined;
  androidSuccessPopup: Boolean = false;

  mounted() {
    (async () => {
      const [
        loggedInEmail,
      ] = await Promise.all([
        getAuthService().getLoggedInEmail(),
      ])

      if (loggedInEmail != null) {
        this.$router.replace({
          name: 'mainPage',
        })
      } 

      this.isAndroidContext = getAndroidContext().isAndroidContext()
      const url = document.URL;
      if (url.includes('token')) {
        //@ts-ignore
        this.tokenURL = true;
      }
      else {
        //@ts-ignore
        this.tokenURL = false;
      }
    })()
  }

  async checkForm(status: number) {
    if (this.isEmailValid(this.email) && status === 1) {
      this.isLoading = true
      const result = await getAccountService().sendResetPasswordProcedure(this.email)
      if (result['hydra:description'] === 'User with put email does not exist') {
        this.isLoading = false
        this.loadingError = true
        this.animate = true
        this.emailNotExist = true
      }
      if (result &&
          result['hydra:description'] !== 'User with put email does not exist') {
        this.isLoading = false
        this.emailNotExist = false
        if (this.isAndroidContext) {
          this.androidSuccessPopup = true
        } else {
          this.isRecoveryPopup1 = true
        }
      }
    } else {
      this.loadingError = true
      this.emailNotExist = false
      this.animate = true
    }
    //@ts-ignore
    if (this.tokenURL && status===0 && this.newPassword===this.repeatedPassword && this.newPassword.length>7) {
      this.isLoading = true
      //@ts-ignore
      const startTokenIndex = document.URL.indexOf('=')
      const token = document.URL.slice(startTokenIndex + 1, document.URL.length)
      const payload = [{
        //@ts-ignore
        'newPassword': this.newPassword,
          //@ts-ignore
        'retypedNewPassword': this.repeatedPassword,
          //@ts-ignore
        'resetPasswordToken': token,
      }]

      const result = await getAccountService().resetPassword(payload)
      if(result) {
        this.isLoading = false
        this.isRecoveryPopup0 = true
        this.failurePopupPassword = false
      } else {
        this.failurePopupPassword = true
      }
    }
  }

  isEmailValid(email: string) {
    const re = /\S+@\S+/;
    return re.test(email);
  }
}

